module.exports = __webpack_public_path__ + "static/img/practice.2ac4436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/practice.png
// module id = YeCF
// module chunks = 1